import React, { useState, history, useEffect } from "react";
import axios from "axios";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import { useHistory, Link } from "react-router-dom";
import HeaderEtd from '../../../shared/components/HeaderEtd';
import DataEnquiry from '../../enquiry/components/DataEnquiryPortal';
import Button from "@mui/material/Button";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FaUserPlus, FaSearch } from "react-icons/fa";

//import "../printOut/assets/bill.css";
//table
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
//end table

function Administration() {
  const [etd, setEtd] = useState({});
  let appId = etd.AppId;
  const [search, setSearch] = useState([]);
  const [error, seterror] = useState();
  const searchId = {
    search: search,
  };
  /*========== clear field ============*/
  const [inputValue, setInputValue] = useState("");
  const handleUserInput = (e) => {
    setInputValue(e.target.value);
  };
  const resetInputField = () => {
    setInputValue("");
  };
  /*======= end of clear field ========*/

  return (
    <>
<HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Administration Module</i>
                </h2>
              </div>
              <div className="card2">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      <Box textAlign="center">
                        {/* <Link to="/administration">
                          <Button variant="outlined" color="warning">
                            User Management
                          </Button>
                        </Link> */}
                        &nbsp;&nbsp;
                        <Link to="#">
                          <Button variant="contained" color="info">
                            Application Management
                          </Button>
                        </Link>
                        &nbsp;&nbsp;
                        <Link to="/stockmngt">
                          <Button variant="outlined" color="warning">
                            Stock Management
                          </Button>
                        </Link>
                      </Box>
                      <hr />
                      <br />
                      <Tabs defaultIndex={0}>
                        <TabList>
                          <Tab>
                            &nbsp;
                            <b style={{ fontSize: "17px" }}>
                              &nbsp;Application Realocate
                            </b>
                            &nbsp;
                          </Tab>
                          <Tab>
                            &nbsp;
                            <b style={{ fontSize: "17px" }}>
                              &nbsp;Application Reprint
                            </b>
                            &nbsp;
                          </Tab>
                          <Tab>
                            &nbsp;
                            <b style={{ fontSize: "17px" }}>
                              &nbsp;Application Repending
                            </b>
                            &nbsp;
                          </Tab>
                          <Tab>
                            &nbsp;
                            <b style={{ fontSize: "17px" }}>
                              &nbsp;Application Search
                            </b>
                            &nbsp;
                          </Tab>
                        </TabList>
                        <TabPanel>
                          <div className="row">
                            <div className="container">
                              <br />
                              <div className="col-md-12">
                                <div style={{ color: "red" }}>Search Item</div>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  sx={{
                                    "& > :not(style)": {
                                      m: 1,
                                      width: "30ch",
                                    },
                                  }}
                                >
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="Application No."
                                  />
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="ETD No."
                                  />
                                  <Button
                                    variant="contained"
                                    color="info"
                                    style={{
                                      maxHeight: "40px",
                                      maxWidth: "60px",
                                      minWidth: "130px",
                                    }}
                                  >
                                    <FaSearch />
                                    &nbsp;Search
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="warning"
                                    style={{
                                      maxHeight: "40px",
                                      maxWidth: "60px",
                                      minWidth: "130px",
                                    }}
                                  >
                                    Clear
                                  </Button>
                                </Box>
                              </div>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="container">
                              {/* <DataEnquiry /> */}
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel>
                          <div className="row">
                            <div className="container">
                              <br />
                              <div className="col-md-12">
                                <div style={{ color: "red" }}>
                                  ETD Reprint / Deffect
                                </div>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  sx={{
                                    "& > :not(style)": {
                                      m: 1,
                                      width: "30ch",
                                    },
                                  }}
                                >
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="Application No."
                                  />
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="ETD No."
                                  />
                                  <Button
                                    variant="contained"
                                    color="info"
                                    style={{
                                      maxHeight: "40px",
                                      maxWidth: "60px",
                                      minWidth: "130px",
                                    }}
                                  >
                                    <FaSearch />
                                    &nbsp;Search
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="warning"
                                    style={{
                                      maxHeight: "40px",
                                      maxWidth: "60px",
                                      minWidth: "130px",
                                    }}
                                  >
                                    Clear
                                  </Button>
                                </Box>
                              </div>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="container">
                              <DataEnquiry />
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel>
                          <div className="row">
                            <div className="container">
                              <br />
                              <div className="col-md-12">
                                <div style={{ color: "red" }}>
                                  Repending Application
                                </div>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  sx={{
                                    "& > :not(style)": {
                                      m: 1,
                                      width: "30ch",
                                    },
                                  }}
                                >
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="Application No."
                                  />
                                  <Button
                                    variant="contained"
                                    color="info"
                                    style={{
                                      maxHeight: "40px",
                                      maxWidth: "60px",
                                      minWidth: "130px",
                                    }}
                                  >
                                    <FaSearch />
                                    &nbsp;Search
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    color="warning"
                                    style={{
                                      maxHeight: "40px",
                                      maxWidth: "60px",
                                      minWidth: "130px",
                                    }}
                                  >
                                    Clear
                                  </Button>
                                </Box>
                              </div>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="container">
                              <DataEnquiry />
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel>
                          <div className="row">
                            <div className="container">
                              <br />
                              <div className="col-md-12">
                                <div style={{ color: "red" }}>
                                  Application Search
                                </div>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  sx={{
                                    "& > :not(style)": {
                                      m: 1,
                                      width: "30ch",
                                    },
                                  }}
                                >
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="Application No."
                                  />
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="ETD No."
                                  />
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="Phone No."
                                  />
                                  <TextField
                                    id="demo-helper-text-misaligned-no-helper"
                                    label="Names"
                                  />
                                </Box>

                                <div className="col-md-12">
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "30ch",
                                      },
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      color="info"
                                      style={{
                                        maxHeight: "40px",
                                        minWidth: "267px",
                                      }}
                                    >
                                      <FaSearch />
                                      &nbsp;Search
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      color="warning"
                                      style={{
                                        maxHeight: "40px",
                                        minWidth: "267px",
                                      }}
                                    >
                                      Clear
                                    </Button>
                                  </Box>
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                          <br />
                          <div className="row">
                            <div className="container">
                              <DataEnquiry />
                            </div>
                          </div>
                        </TabPanel>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Administration;
